import { Commit, Dispatch } from 'vuex';
import { OptionsSuiviInterventionState } from '@/modules/OptionsSuiviInterventions/store/state';

export interface SuiviDIModuleActionTypes {
    commit: Commit,
    state: OptionsSuiviInterventionState,
    getters: any,
    dispatch: Dispatch,
}

export enum OptionsSuiviDIModuleAction {
    GET_SUIVI_DI = 'GET_SUIVI_DI',
    ACTIVER_SUIVI_DI = 'ACTIVER_SUIVI_DI',
    DESACTIVER_SUIVI_DI = 'DESACTIVER_SUIVI_DI',
    ACTIVER_EMAIL_SUIVI = 'ACTIVER_EMAIL_SUIVI',
    DESACTIVER_EMAIL_SUIVI = 'DESACTIVER_EMAIL_SUIVI',
    SUPPRIMER_EMAIL_SUIVI = 'SUPPRIMER_EMAIL_SUIVI',
    AJOUTER_EMAIL_SUIVI = 'AJOUTER_EMAIL_SUIVI',

}
